import { PremiumDashboard } from '@/components/premium-dashboard/PremiumDashboard';

export default function Dashboard() {
  return <PremiumDashboard />;
}
